import { render } from "./PieChartWithLegend.vue?vue&type=template&id=76c92432&scoped=true"
import script from "./PieChartWithLegend.vue?vue&type=script&lang=js"
export * from "./PieChartWithLegend.vue?vue&type=script&lang=js"

import "./PieChartWithLegend.vue?vue&type=style&index=0&id=76c92432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c92432"]])

export default __exports__